module.exports = __webpack_public_path__ + "media/images/OPL 116-dcaa93a6e7bd78a06a9331e70c1bc5c6.png";